import { mobileMaxWidth } from './useIsMobile';

export const mobileCss = (css: TemplateStringsArray | string) => `
    @media (max-width: ${mobileMaxWidth}px) {
        ${css}
    }
`;
